exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1mTV9aozFZ4r2PXYzrbENz {\n  overflow: hidden;\n  height: 100%;\n}\n._1mTV9aozFZ4r2PXYzrbENz td div {\n  font-size: 1rem;\n}\n._1mTV9aozFZ4r2PXYzrbENz thead th {\n  font-size: 1rem;\n}\n._3OTeqGqupn9TZ5fi3P2x3A {\n  display: flex;\n  justify-content: flex-end;\n}\n._3OTeqGqupn9TZ5fi3P2x3A ._2ci-Vno7K75C-OyGfeaFWN {\n  margin-right: 8px;\n}\n", ""]);
// Exports
exports.locals = {
	"base": "_1mTV9aozFZ4r2PXYzrbENz",
	"footer": "_3OTeqGqupn9TZ5fi3P2x3A",
	"button": "_2ci-Vno7K75C-OyGfeaFWN"
};